import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config";
import { toast } from "react-toastify";

function StudentEdit() {

    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [name, setName] = useState("");
    const [city, setCity] = useState("");
    const [phone, setPhone] = useState("");

    const [photo, setPhoto] = useState(null);
    const [oldPhoto, setOldPhoto] = useState("");

    useEffect(() => {
        getStudent();
    }, []);

    const getStudent = async () => {

        try {

            const response = await axios.get(
                `${API_URL}/api/students/${id}`
            );

            const student = response.data.data;

            setName(student.name);
            setCity(student.city);
            setPhone(student.phone);
            setOldPhoto(student.photo);

            setLoading(false);

        } catch (error) {

            toast.error("Unable to load student.");
            setLoading(false);

        }

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const formData = new FormData();

			formData.append("name", name);
			formData.append("city", city);
			formData.append("phone", phone);

			if (photo) {
				formData.append("photo", photo);
			}

            const response = await axios.put(
                `${API_URL}/api/students/${id}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            toast.success(response.data.message);

            setTimeout(() => {
                navigate("/dashboard/students");
            }, 1000);

        } catch (error) {

            toast.error(
                error.response?.data?.message || "Update failed."
            );

        }

    };

    if (loading) {
        return (
            <div className="container mt-5">
                <h4>Loading...</h4>
            </div>
        );
    }

    return (

        <div className="container mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">Update Student</h4>
                </div>

                <div className="card-body">

                    <form onSubmit={handleSubmit}>

                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Student Name
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={name}
                                    onChange={(e) =>
                                        setName(e.target.value)
                                    }
                                    required
                                />

                            </div>

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    City
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={city}
                                    onChange={(e) =>
                                        setCity(e.target.value)
                                    }
                                    required
                                />

                            </div>

                        </div>

                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Phone
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={phone}
                                    onChange={(e) =>
                                        setPhone(e.target.value)
                                    }
                                    required
                                />

                            </div>

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Photo
                                </label>

                                <input
                                    type="file"
                                    className="form-control"
                                    accept="image/*"
                                    onChange={(e) =>
                                        setPhoto(e.target.files[0])
                                    }
                                />

                            </div>

                        </div>

                        {oldPhoto && (

                            <div className="mb-3">

                                <label className="form-label">
                                    Current Photo
                                </label>

                                <br />

                                <img
                                    src={`${API_URL}/uploads/students/${oldPhoto}`}
                                    alt="Student"
                                    width="120"
                                    className="img-thumbnail"
                                />

                            </div>

                        )}

                        <button
                            type="submit"
                            className="btn btn-primary me-2"
                        >
                            Update Student
                        </button>

                        <Link
                            to="/dashboard/students"
                            className="btn btn-secondary"
                        >
                            Back
                        </Link>

                    </form>

                </div>

            </div>

        </div>

    );
}

export default StudentEdit;